<script>
export default {
  name: 'AccountModal',
  data() {
    return {
      roleFields: ['app', { key: 'roles', label: 'Role(s)' }]
    }
  },
  computed: {
    username() {
      return this.$store.state.username
    },
    appRoles() {
      let roles = this.$store.state.role.split(/,/g)
      let items = []
      for (let role of roles) {
        if (/=/.test(role)) {
          items.push({
            app: role.split(/=/)[0],
            roles: role.split(/=/)[1].replace(/;/g, '\n')
          })
        }
      }
      return items
    }
  },
  methods: {
    logout() {
      this.$store.commit('logout')
      this.$bvModal.hide('account-modal')
    }
  }
}
</script>

<template>
  <b-modal id="account-modal" title="Account" size="md" centered hide-footer>
    <b-row>
      <b-col>Username:</b-col>
      <b-col>
        <code>{{ this.username }}</code>
      </b-col>
    </b-row>
    <b-table :fields="roleFields" :items="appRoles" />

    <hr />

    <b-button size="sm" block variant="outline-danger" @click="logout">
      <font-awesome-icon icon="sign-out-alt" />Logout
    </b-button>

    <b-button
      size="sm"
      block
      variant="outline-secondary"
      @click="$bvModal.hide('account-modal')"
    >
      <font-awesome-icon icon="times" />Close
    </b-button>
  </b-modal>
</template>

<style scoped></style>
